import { defaultHttpClient } from '../../httpClient';

interface PostGoodsReportRequest {
  goods_sno: number;
  comments: string;
}

export const postGoodsReport = (body: PostGoodsReportRequest) => {
  return defaultHttpClient
    .request<void>({
      method: 'POST',
      url: '/api/v2/reports/goods/',
      data: body,
    })
    .then(result => result.data);
};